import * as React from 'react';

export const Bold = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M4 4a1 1 0 011-1h4.5a3.5 3.5 0 012.475 1.025c.59.59.948 1.369 1.016 2.237L13 6.5a3.5 3.5 0 01-.65 2.031 3.525 3.525 0 011.644 2.772L14 11.5a3.5 3.5 0 01-3.5 3.5H5a1 1 0 01-1-1zm6.5 6H6v3h4.5c.828 0 1.5-.672 1.5-1.468l-.003-.132A1.5 1.5 0 0010.5 10zm-1-5H6v3h3.5a1.5 1.5 0 001.06-.44c.282-.28.44-.662.44-1.02l-.005-.159A1.5 1.5 0 009.5 5z"
      />
    </svg>
  );
};

export const Italic = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M13 3a1 1 0 01.117 1.993L13 5h-2.181l-1.6 8H11a1 1 0 01.117 1.993L11 15H5a1 1 0 01-.117-1.993L5 13h2.18l1.6-8H7a1 1 0 01-.117-1.993L7 3h6z"
      />
    </svg>
  );
};
export const Link = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      strokeWidth={3}
      fill={'none'}
    >
      <path
        stroke="currentColor"
        d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
      />
      <path
        stroke="currentColor"
        d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
      />
    </svg>
  );
};

export const Underline = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M14.5 15a.5.5 0 110 1h-11a.5.5 0 110-1h11zM13 2a1 1 0 01.993.883L14 3v6.003A5.013 5.013 0 018.997 14a5.013 5.013 0 01-4.992-4.783L4 9V3a1 1 0 011.993-.117L6 3v5.997A3.01 3.01 0 008.997 12a3.012 3.012 0 002.997-2.824L12 9V3a1 1 0 011-1z"
      />
    </svg>
  );
};

export const Subscript = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g fill="currentColor" fillRule="nonzero">
        <path d="M15.5 14h-1.639a3.858 3.858 0 001.914-2.975 1.8 1.8 0 00-1.6-1.751 1.921 1.921 0 00-2.154 1.426.5.5 0 00.957.291.914.914 0 011.053-.725.81.81 0 01.744.762c0 1.076-1.17 1.87-1.94 2.43-.43.192-.741.58-.835 1.042a.5.5 0 00.5.5h3a.5.5 0 000-1zM9.65 4.241a1 1 0 00-1.409.108L6 6.964 3.759 4.349a1 1 0 10-1.518 1.3L4.684 8.5l-2.443 2.85a1 1 0 101.518 1.3L6 10.036l2.241 2.614a1 1 0 101.518-1.3L7.316 8.5l2.443-2.849a1 1 0 00-.109-1.41z" />
      </g>
    </svg>
  );
};

export const Superscript = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g fill="currentColor" fillRule="nonzero">
        <path d="M15.5 6h-1.639a4.015 4.015 0 001.914-2.975 1.8 1.8 0 00-1.6-1.751A1.922 1.922 0 0012.021 2.7a.5.5 0 00.957.291.917.917 0 011.053-.725.81.81 0 01.744.762c0 1.077-1.164 1.925-1.934 2.486A1.423 1.423 0 0012 6.5a.5.5 0 00.5.5h3a.5.5 0 100-1zM9.651 4.241a1 1 0 00-1.41.108L6 6.964 3.759 4.349a1 1 0 10-1.519 1.3L4.683 8.5l-2.442 2.85a1 1 0 101.519 1.3L6 10.036l2.241 2.614a1 1 0 001.519-1.3L7.317 8.5l2.442-2.849a1 1 0 00-.108-1.41z" />
      </g>
    </svg>
  );
};
